import { render, staticRenderFns } from "./mein-projekt.vue?vue&type=template&id=5fc94782&scoped=true&lang=pug&"
import script from "./mein-projekt.vue?vue&type=script&lang=js&"
export * from "./mein-projekt.vue?vue&type=script&lang=js&"
import style0 from "./mein-projekt.vue?vue&type=style&index=0&id=5fc94782&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc94782",
  null
  
)

export default component.exports